<template>
    <a
        class="header-icon"
        href="#"
        :title="titlePanel"
        data-toggle="tooltip-city"
        @click.prevent.stop="onClick">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
            <path fill="currentColor" d="M 8 2 C 6.169 2 4.5757656 3.2743906 4.1347656 5.0253906 C 3.0557656 5.1843906 2.1982031 6.0411563 2.0332031 7.1601562 C 0.83420313 7.5671563 4.6351811e-17 8.706 0 10 C 0 11.654 1.346 13 3 13 L 13 13 C 14.654 13 16 11.654 16 10 C 16 9.101 15.600062 8.2633125 14.914062 7.6953125 C 14.971063 7.4643125 15 7.231 15 7 C 15 5.18 13.389188 3.6958281 11.492188 4.0488281 C 10.790188 2.7918281 9.463 2 8 2 z M 8 3 C 9.208 3 10.292672 3.7180781 10.763672 4.8300781 L 10.943359 5.2558594 L 11.380859 5.109375 C 11.606859 5.035375 11.809 5 12 5 C 13.103 5 14 5.897 14 7 C 14 7.233 13.953328 7.4739375 13.861328 7.7109375 L 13.716797 8.09375 L 14.0625 8.3125 C 14.6495 8.6845 15 9.314 15 10 C 15 11.103 14.103 12 13 12 L 3 12 C 1.897 12 1 11.103 1 10 C 1 9.051 1.6745156 8.2260625 2.6035156 8.0390625 L 3.0117188 7.921875 L 3 7.5 C 3 6.673 3.6732188 5.9990938 4.4492188 5.9960938 L 4.5507812 6.0058594 L 4.9824219 6.0058594 L 5.0449219 5.5742188 C 5.2539219 4.1062187 6.525 3 8 3 z M 6.7519531 5.9433594 L 6.0449219 6.6503906 L 7.7929688 8.3984375 L 6.0449219 10.146484 L 6.7519531 10.853516 L 8.5 9.1054688 L 10.248047 10.853516 L 10.955078 10.146484 L 9.2070312 8.3984375 L 10.955078 6.6503906 L 10.248047 5.9433594 L 8.5 7.6914062 L 6.7519531 5.9433594 z"/>
        </svg>
    </a>
</template>

<script>
    import HeaderBroadcastingMixin from './mixins/HeaderBroadcastingMixin';

    export default {
        mixins: [
            HeaderBroadcastingMixin,
        ],
        props: {
            idPanel: {
                type: String,
                default: 'disconnected'
            },
            allowReconnect: {
                type: Boolean,
                default: true
            }
        },
    };
</script>